import React from 'react'

import ViewName from "./view-name"
import TypeField from "./type-field"
import ViewAccessBlock from "./view-access"
import ViewLocation from "./view-location"
import FormManager from "../../../../../../../core/gd-form/common/form-manager"
import CustomView from "../../../../../../../core/model2/custom-view/custom-view"
import {useForceUpdate} from "../../../../../../../core/gd/utils/dom-and-react/react-utils"

type Props = {
    view        : CustomView
    form        : FormManager
    mode        : 'create' | 'update'

    hideAccess? : boolean
}

// const debug = "CommonBlock"
const debug = false

export default function CommonBlock(props: Props) {

    const forceUpdate = useForceUpdate()

    const onLocationChanged = () => {
        forceUpdate() // is required because ViewAccessBlock may become hidden/visible depending on location
    }

    const showTypeField = props.mode === 'update'
    const showAccess    = props.view.canShare && !props.hideAccess

    debug && console.log(debug, 'render', showAccess, props.view)

    return (
        <>
            <ViewName form={props.form}/>
            <ViewLocation form      = {props.form}
                          view      = {props.view}
                          onChange  = {onLocationChanged}/>
            {showTypeField && <TypeField view={props.view} />}
            {showAccess && <ViewAccessBlock form={props.form} view={props.view}/>}
            <div className="row subgroup"/>
        </>
    )
}